import { Box } from '@mui/material'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'

function Layout({children}) {
  return (
    <Box className='h-100 w-100 content'>
      <Header/>
      <Box>
        {children}
      </Box>
      <Footer/>
    </Box>
  )
}

export default Layout
